import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import {
  type FieldType,
  FIELD_TYPES,
  getFieldTypeDisplayLabel,
} from './types';

interface FieldTypeSelectorProps {
  value: FieldType;
  onChange: (type: FieldType) => void;
  label?: string;
}

export const FieldTypeSelector = ({
  value,
  onChange,
  label = 'Field Type',
}: FieldTypeSelectorProps) => (
  <FormControl fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as FieldType)}
      label={label}
    >
      {!(FIELD_TYPES as readonly string[]).includes(value) && (
        <MenuItem value={value}>
          {getFieldTypeDisplayLabel(value)} (legacy)
        </MenuItem>
      )}
      {FIELD_TYPES.map((type) => (
        <MenuItem key={type} value={type}>
          {getFieldTypeDisplayLabel(type)}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
